import React from "react";

interface DeleteUndoToastProps {
  locationName: string;
  onUndo: () => void;
}

const DeleteUndoToast: React.FC<DeleteUndoToastProps> = ({
  locationName,
  onUndo,
}) => {
  return (
    <div className="dom-delete-undo-toast" role="status" aria-live="polite">
      <span className="dom-delete-undo-text">{locationName} deleted.</span>
      <button type="button" className="dom-delete-undo-btn" onClick={onUndo}>
        Undo
      </button>
    </div>
  );
};

export default DeleteUndoToast;
